import React from 'react'
import { Card, Tree } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { FormComponent } from '../../../../BaseComponent'
import { DashboardProps, TreeData } from '../types'


export default class DashboardSettings extends FormComponent<DashboardProps> {

  private mountTree = (data: Record<any, any> | any[], path?: string): TreeData[] => {
    const tree: TreeData[] = []

    if (data instanceof Array) {
      data.forEach((v, i) => {
        tree.push({
          key: `${path}_${i}`,
          title: JSON.stringify(v)
        })
      })
    } else {
      Object.keys(data).forEach((key, index) => {
        if (data[key] !== null && data[key] !== undefined) {
          if (typeof data[key] === 'object') {
            tree.push({
              key: `${path}_${index}_${key}`,
              title: key.toString(),
              children: this.mountTree(data[key], `${path}_${index}_${key}`)
            })
          } else {
            tree.push({
              key: `${path}_${index}_${key}`,
              title: key.toString(),
              children: [
                {
                  key: `${path}_${key}_${data[key]}`,
                  title: data[key].toString()
                }
              ]
            })
          }
        }
      })
    }

    return tree
  }

  render() {
    return (
      <Card title="Settings">
        <Tree
          switcherIcon={<DownOutlined />}
          treeData={this.mountTree(this.props.context.preview?.settings || {}, "settings")}
          showLine
        />
      </Card>
    )
  }
}
